import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import logo from '../assets/logo.svg';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { label: 'Usługi', id: 'services' },
    { label: 'Dlaczego my', id: 'why-us' },
    { label: 'Realizacje', id: 'why-we' },
  ];

  return (
    <>
      <motion.section
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col md:pt-[1rem] sm:pt-[0.8rem] pt-[0.8rem] lg:pt-[24px] md:pb-[1rem] sm:pb-[0.8rem] pb-[0.8rem] lg:pb-[24px] border-solid border-opacity-[100%] border-[#525252] border-b-[1px] border-t-[0px] border-r-[0px] border-l-[0px] sticky top-[0px] transform opacity-[100%] bg-[#171717] z-[100]"
      >
        <div className="flex flex-col w-[100%] max-w-[1280px] mr-[auto] ml-[auto] md:pr-[4rem] sm:pr-[4rem] pr-[1.5rem] lg:pr-[32px] md:pl-[4rem] sm:pl-[4rem] pl-[1.5rem] lg:pl-[32px] 2xl:max-w-[1536px]">
          <div className="flex gap-[12px] flex-row justify-between items-center">
            <motion.img
              src={logo}
              alt="Omega Post Logo"
              whileHover={{ opacity: 0.8 }}
              className="max-w-[100%] object-cover sm:h-[31px] h-[25px] md:h-[32px] sm:w-[179px] w-[144px] md:w-[187px] cursor-pointer"
              id="logo"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            />
            <div className="sm:hidden hidden md:flex flex-row md:gap-[2.5rem] sm:gap-[2.5rem] gap-[2.5rem] lg:gap-[3rem]">
              {navItems.map((item) => (
                <motion.span
                  key={item.label}
                  onClick={() => scrollToSection(item.id)}
                  whileHover={{ opacity: 0.8 }}
                  className="block md:text-[18px] sm:text-[18px] text-[18px] lg:text-[20px] font-medium 2xl:text-opacity-[100%] 2xl:text-[#ffffff] opacity-[100%] text-[#ffffff] cursor-pointer"
                >
                  {item.label}
                </motion.span>
              ))}
            </div>
            <motion.button
              onClick={() => scrollToSection('contact')}
              whileHover={{ opacity: 0.9 }}
              whileTap={{ scale: 0.95 }}
              type="button"
              className="sm:hidden hidden md:flex flex-row items-center justify-center border-[transparent] border-[1px] border-solid inline-block focus:outline-none rounded-[12px] font-medium text-[16px] tracking-[-0.025em] leading-[1.5em] bg-opacity-[100%] text-opacity-[100%] text-[#000000] bg-[#ffffff] hover:bg-[#525252] hover:text-[#ffffff] transition-colors duration-300 pr-[2rem] pl-[2rem] pt-[0.5rem] pb-[0.5rem]"
            >
              <span className="md:text-[18px] sm:text-[18px] text-[18px] lg:text-[18px] font-medium">Kontakt</span>
            </motion.button>
            <div id="menu" className="pt-[0.5rem] pb-[0.5rem] pl-[0.5rem] pr-[0.5rem] sm:block block md:hidden">
              <div
                onClick={() => setIsMobileMenuOpen(true)}
                className="block h-auto sm:w-[2rem] w-[2rem] md:w-[2rem] text-opacity-[100%] text-[#ffffff] cursor-pointer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-menu-icon lucide-menu">
                  <path d="M4 5h16"></path>
                  <path d="M4 12h16"></path>
                  <path d="M4 19h16"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </motion.section>

      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-[#171717] z-[200] flex flex-col p-6"
          >
            <div className="flex justify-between items-center mb-12">
              <img
                src={logo}
                alt="Omega Post Logo"
                className="h-[25px] w-[144px]"
              />
              <button onClick={() => setIsMobileMenuOpen(false)} className="text-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 6L6 18"></path>
                  <path d="M6 6l12 12"></path>
                </svg>
              </button>
            </div>

            <div className="flex flex-col gap-[1rem]">
              {navItems.map((item) => (
                <span
                  key={item.label}
                  onClick={() => scrollToSection(item.id)}
                  className="text-[2rem] font-medium text-white cursor-pointer"
                >
                  {item.label}
                </span>
              ))}
              <span
                onClick={() => scrollToSection('contact')}
                className="text-[2rem] font-medium text-white cursor-pointer"
              >
                Kontakt
              </span>
            </div>

            <div className="mt-[2rem] flex flex-col gap-4 text-[#a3a3a3]">
              <span className="text-[16px]">witaj@omegapost.pl</span>
              <span className="text-[16px]">+48 793 959 931</span>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
